export default __webpack_public_path__ + "static/media/html5.c77fed67.png";